import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap-override.css';
import 'cfa-react-components/dist/styles.min.css';
import './styles/index.css';
import './styles/cfa-design-system-override.css';
import { GoogleAnalyticsProvider } from 'googleAnalytics/googleAnalyticsContext';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <GoogleAnalyticsProvider measurementId="G-W10Z8MTTF7">
      <App />
    </GoogleAnalyticsProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
